/*
 |--------------------------------------------------------------------------
 | UI / state.js
 |--------------------------------------------------------------------------
 */

export default {
    viewport: {
        height: null
    },
    global: {
        isMobile: true,
        detectedLanguage: 'en-GB',
        translation: {},
        currentCoordinates: {}
    },
    overlay: {
        recommendation: false,
        feedback: false,
        map: false
    }
}
